import { axiosInstance } from '../shared/axios/axiosConfig';
import { PARTNER_MGMT_API_URL } from 'services/constants';

/**
 * Get the enum list (label of values) of countries for the dropdown values.
 */
const getCountries = async () => {
  const response = await axiosInstance.get(`${PARTNER_MGMT_API_URL}/static/countries`);
  return response.data;
};

/**
 * Search my team partners for dropdown selection
 * Returns partner search results with name, globalPartnerId, and type
 * @param searchQuery Optional search query to filter partners (minimum 2 characters)
 */
const searchMyTeamPartners = async (searchQuery?: string) => {
  const params = new URLSearchParams({ includeTeamPartners: 'true' });
  if (searchQuery && searchQuery.length >= 2) {
    params.append('search', searchQuery);
  }
  const response = await axiosInstance.get(`${PARTNER_MGMT_API_URL}/partners/dropdown?${params.toString()}`);
  return response.data;
};

const getPartnerRelations = async (partnerId: string) => {
  const response = await axiosInstance.get(`${PARTNER_MGMT_API_URL}/relations?partnerId=${partnerId}`);
  return response.data;
};

const partnerService = {
  getCountries,
  searchMyTeamPartners,
  getPartnerRelations,
};
export default partnerService;
